import SDK from './core';

export const setUserProfile = (name, image, status, mobile, email) =>
   SDK.setUserProfile(name, image, status, mobile, email);
export const getUsersProfile = userJids => SDK.getUsersProfile(userJids);
export const getFriendsList = () => SDK.getFriendsList();
export const getUsersList = (search, page, size) => SDK.getUsersList(search, page, size);
export const getMediaURL = uri => SDK.getMediaURL(uri);
export const getLastSeen = jid => SDK.getLastSeen(jid);
export const blockUser = jid => SDK.blockUser(jid);
export const unblockUser = jid => SDK.unblockUser(jid);
